export default "<app-youtube-viewer [youtube]=\"youtube\" [verbose]=\"verbose\"></app-youtube-viewer>"